import React from 'react';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

export const CenteredSpinner = ({ type = 'TailSpin', color = 'black', size = 50, children }) => {
  return (
    <div className="spinner-overlay">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Loader type={type} color={color} height={size} width={size} />
        {children ? <div style={{ marginTop: 12, textAlign: 'center' }}>{children}</div> : null}
      </div>
    </div>
  );
};

export default CenteredSpinner;
